/*
 * pdp-gallery-momentum.js — Galería del PDP en MÓVIL con momentum real (transform, sin scroll nativo).
 * Capa ADITIVA sobre el <carousel-slider> NATIVO de Symmetry (no lo subclasea). Activa SOLO en
 * carousel-slider[data-momentum="true"] y ≤749px. Sin scrollLeft => sin el bug de iOS (re-grab del
 * scroll-snap tras scroll programático). MOTOR: requestAnimationFrame único; el dedo manda 1:1 (sin
 * reflows por frame), la soltada decide por velocidad+distancia y asienta con MUELLE críticamente
 * amortiguado; el bucle es infinito BIDIRECCIONAL por clones + teleport de OFFSET por-frame (invisible).
 * Re-emite on:carousel-slider:select + is-active + updateDynamicHeight => dots/zoom/variante/thumbnails OK.
 * Reversible: setting enable_momentum_gallery (default OFF).
 */
(function () {
  'use strict';
  // Sin Pointer Events (Safari <=12, WebViews Android muy viejas) NO tomamos el control: así no
  // desmontamos el scroll nativo y el usuario conserva el carrusel funcional (degradación segura).
  if (!window.matchMedia || !window.requestAnimationFrame || !window.PointerEvent) return;

  var MOBILE = '(max-width: 749px)';

  // ---------- knobs de FEEL (afinar en iPhone) ----------
  // Asentado = ease-out EXPONENCIAL hacia el destino: frena suave y NUNCA se pasa (sin rebote/muelle).
  var APPROACH    = 0.25;   // 0..1: fracción que se acerca al destino por frame (mayor = más rápido/seco). 0.25 ~= 0,2 s
  var SETTLE_EPS  = 0.5;    // px: por debajo se asienta exacto
  var DIST_RATIO  = 0.16;   // distancia mínima (frac. ancho) para avanzar a la siguiente
  var FLICK_VMS   = 0.30;   // px/ms: velocidad mínima de flick para avanzar aunque la distancia sea corta
  var TAP_MOVE    = 8;      // px: por debajo es TAP (deja pasar el click -> zoom)
  var CLAIM_RATIO = 0.8;    // |dx| > |dy|*ratio para reclamar horizontal (0.8 = admite swipes diagonales; vertical puro NO se reclama)
  // Una foto por swipe (como un carrusel normal); el flick NO salta varias.

  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once:true }); else fn(); }
  function clamp(v,a,b){ return v<a?a:(v>b?b:v); }
  function now(){ return (window.performance && performance.now) ? performance.now() : Date.now(); }

  function MomentumGallery(carousel){
    this.carousel = carousel;
    this.slider = carousel.querySelector('.slider');
    this.grid = carousel.querySelector('.slider__grid');
    if (!this.slider || !this.grid) return;
    carousel.__momentum = this;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.index = 0; this.pos = 0; this.vel = 0; this.target = 0;
    this.dragging = false; this.ticking = false; this.lastEmitIdx = -1;
    this.build();
    if (!this.ok) return;
    this.patchCarousel();
    this.bindPointer();
    this.buildDots();
    this.bindLifecycle();
    this.emitFull();
  }
  var P = MomentumGallery.prototype;

  P.reals = function(){
    return Array.prototype.slice.call(this.grid.children).filter(function(s){ return !s.hidden && !s.hasAttribute('data-clone'); });
  };

  P.build = function(){
    var old = this.grid.querySelectorAll('[data-clone]'); for (var k=0;k<old.length;k++) old[k].remove();
    var slides = this.reals();
    this.n = slides.length;
    this.W = Math.round(this.slider.getBoundingClientRect().width);
    if (!this.W || this.n < 1){ this.ok = false; return; }
    var act = this.grid.querySelector('.slider__item.is-active');
    this.index = act ? Math.max(0, slides.indexOf(act)) : 0;
    this.carousel.classList.add('momentum-active');
    if (this.n >= 2){
      this.lead = this.clone(slides[this.n - 1]);   // clon de la última a la IZQUIERDA
      this.trail = this.clone(slides[0]);           // clon de la primera a la DERECHA
      this.grid.insertBefore(this.lead, this.grid.firstChild);
      this.grid.appendChild(this.trail);            // track: [lead, R0..R(n-1), trail]; R(i) en pos -(i+1)*W
    }
    if (this.carousel.dataset.mobileZoom === 'false') {
      // desactivar el zoom (tap para ampliar) en móvil: neutralizar a.show-gallery en los slides reales
      var rs = this.reals();
      for (var z = 0; z < rs.length; z++) {
        var ls = rs[z].querySelectorAll('a.show-gallery');
        for (var q = 0; q < ls.length; q++) { ls[q].classList.remove('show-gallery'); ls[q].removeAttribute('href'); ls[q].style.cursor = 'default'; }
      }
    }
    this.grid.style.transition = 'none';            // el motor anima por transform, sin transición CSS
    this.pos = this.target = this.offsetFor(this.index);
    this.apply();
    this.ok = true;
  };

  P.clone = function(slide){
    var c = slide.cloneNode(true);
    c.setAttribute('data-clone',''); c.removeAttribute('data-media-id'); c.removeAttribute('id');
    c.classList.remove('is-active'); c.setAttribute('aria-hidden','true'); c.setAttribute('tabindex','-1');
    var a = c.querySelectorAll('a.show-gallery'); for (var i=0;i<a.length;i++){ a[i].classList.remove('show-gallery'); a[i].removeAttribute('href'); a[i].style.pointerEvents='none'; }
    var h = c.querySelectorAll('video, iframe, model-viewer, deferred-media, template, script'); for (var j=0;j<h.length;j++) h[j].remove();
    return c;
  };

  P.offsetFor = function(i){ return this.n >= 2 ? -(i + 1) * this.W : 0; };
  P.apply = function(){ this.grid.style.transform = 'translate3d(' + this.pos + 'px,0,0)'; };

  // ---------- MOTOR rAF ----------
  P.startTick = function(){
    if (this.ticking) return;
    this.ticking = true;
    var self = this;
    var loop = function(){ if (self.step()) self._raf = requestAnimationFrame(loop); else self.ticking = false; };
    self._raf = requestAnimationFrame(loop);
  };

  P.step = function(){
    if (this.dragging){
      // el dedo manda 1:1 (la posición la fija pointermove); aquí solo normalizamos+pintamos
      this.normalize();
      this.apply();
      this.syncIndex(false);
      return true; // seguimos hasta soltar
    }
    // asentado: ease-out EXPONENCIAL hacia this.target (decelera y nunca se pasa => sin rebote)
    var d = this.target - this.pos;
    if (Math.abs(d) < SETTLE_EPS){
      this.pos = this.target;
      this.normalize(); this.apply(); this.syncIndex(true);
      return false; // parar
    }
    this.pos += d * APPROACH;
    this.normalize(); this.apply(); this.syncIndex(false);
    return true;
  };

  // teleport de OFFSET por-frame al cruzar a un clon (invisible: el clon === el slide real)
  P.normalize = function(){
    if (this.n < 2) return;
    var span = this.n * this.W;
    var lo = -(this.n + 0.5) * this.W; // entrando en trail (clon de R0)
    var hi = -0.5 * this.W;            // entrando en lead (clon de R(n-1))
    if (this.pos <= lo){ this.pos += span; this.target += span; this.dragBase += span; }
    else if (this.pos >= hi){ this.pos -= span; this.target -= span; this.dragBase -= span; }
  };

  P.syncIndex = function(final){
    var idx = Math.round(-this.pos / this.W) - 1;
    idx = ((idx % this.n) + this.n) % this.n;
    this.index = idx;
    if (idx !== this.lastEmitIdx){ this.lastEmitIdx = idx; this.setActiveDot(idx); if (final) this.emitFull(); }
    else if (final) this.emitFull();
  };

  // ---------- POINTER ----------
  P.bindPointer = function(){
    var self = this;
    var down=false, claimed=false, decided=false, startX=0, startY=0, lastX=0, lastT=0, vMs=0, startIdx=0;
    function onDown(e){
      down=true; claimed=false; decided=false;
      startX=e.clientX; startY=e.clientY; lastX=e.clientX; lastT=now(); vMs=0;
      self.dragBase = self.pos; self.vel = 0; startIdx = self.index;
      // capturar a mitad de asentado: cortar el muelle y seguir desde donde esté
      self.dragging = false;
    }
    function onMove(e){
      if (!down) return;
      var dx=e.clientX-startX, dy=e.clientY-startY;
      if (!decided){
        if (Math.abs(dx) < TAP_MOVE && Math.abs(dy) < TAP_MOVE) return;
        decided=true; claimed = Math.abs(dx) > Math.abs(dy)*CLAIM_RATIO;
        if (claimed){ self.dragging = true; self.startTick(); if (self.slider.setPointerCapture && e.pointerId!=null){ try{ self.slider.setPointerCapture(e.pointerId); }catch(x){} } }
      }
      if (!claimed) return;            // vertical: deja scrollear la página
      if (e.cancelable) e.preventDefault();
      var t=now(), dt=t-lastT; if (dt>0){ var inst=(e.clientX-lastX)/dt; vMs = 0.7*vMs + 0.3*inst; }
      lastX=e.clientX; lastT=t;
      self.pos = self.dragBase + dx;   // 1:1 con el dedo (el rAF lo pinta)
    }
    function onUp(){
      if (!down) return; down=false;
      if (!claimed) return;            // TAP -> el click pasa al a.show-gallery (zoom)
      self.dragging = false;
      var slideFloat = -self.pos / self.W - 1;    // índice fraccional actual
      var moved = slideFloat - startIdx;          // >0 = arrastrado hacia adelante
      var t = startIdx;                           // por defecto: volver a la foto actual
      if (Math.abs(vMs) >= FLICK_VMS) t = startIdx + (vMs < 0 ? 1 : -1);            // flick -> una foto en su dirección
      else if (Math.abs(moved) >= DIST_RATIO) t = startIdx + (moved > 0 ? 1 : -1); // si no, por distancia
      self.target = -(t + 1) * self.W;
      if (self.reduced){ self.pos = self.target; self.normalize(); self.apply(); self.syncIndex(true); return; }
      self.startTick();
    }
    this.slider.addEventListener('pointerdown', onDown, { passive:true });
    this.slider.addEventListener('pointermove', onMove, { passive:false });
    this.slider.addEventListener('pointerup', onUp, { passive:true });
    // pointercancel: iOS WebKit lo dispara espurio a media pasada. Si ya habíamos reclamado el
    // gesto horizontal, lo tratamos como SOLTAR (decide destino por velocidad/distancia) en vez de
    // rebotar a la foto actual -> el swipe cuenta aunque el sistema cancele el puntero.
    this.slider.addEventListener('pointercancel', function(){ if (down && claimed) onUp(); else down=false; }, { passive:true });
  };

  // navegación directa (dot / variante / thumbnail): muelle directo al slide destino
  P.animateToIndex = function(target){
    target = clamp(((target % this.n) + this.n) % this.n, 0, this.n - 1);
    if (this.n < 2){ this.index = target; this.emitFull(); return; }
    this.dragging = false; this.vel = 0;
    this.target = this.offsetFor(target);
    if (this.reduced){ this.pos = this.target; this.normalize(); this.apply(); this.index = target; this.emitFull(); return; }
    this.startTick();
  };

  // ---------- SEÑALES que el tema ya consume ----------
  P.emitFull = function(){
    var slides = this.reals(); var slide = slides[this.index]; if (!slide) return;
    for (var i=0;i<slides.length;i++) slides[i].classList.toggle('is-active', i===this.index);
    try { this.carousel.dispatchEvent(new CustomEvent('on:carousel-slider:select', { bubbles:true, detail:{ index:this.index, slide:slide } })); } catch(e){}
    try { this.carousel.currentIndex = this.index; if (typeof this.carousel.updateDynamicHeight === 'function') this.carousel.updateDynamicHeight(); } catch(e2){}
    this.setActiveDot(this.index);
  };

  // ---------- DOTS (dueño en modo momentum) ----------
  P.buildDots = function(){
    var mg = this.carousel.closest('media-gallery');
    var wrap = mg && mg.querySelector('.main-image > .mobile-carousel-dots');
    if (!wrap){ this.dots = null; return; }
    wrap.innerHTML=''; wrap.hidden=false; wrap.setAttribute('role','tablist'); wrap.setAttribute('aria-hidden','false');
    var self=this;
    for (var i=0;i<this.n;i++){ var b=document.createElement('button'); b.type='button'; b.className='mobile-dot'; b.dataset.index=String(i); b.setAttribute('aria-label','Ir a imagen '+(i+1)+' de '+this.n); wrap.appendChild(b); }
    wrap.addEventListener('click', function(e){ var btn=e.target.closest('.mobile-dot'); if (!btn) return; self.animateToIndex(parseInt(btn.dataset.index||'0',10)); });
    this.dots = wrap; this.setActiveDot(this.index);
  };
  P.setActiveDot = function(idx){ if (!this.dots) return; var d=this.dots.querySelectorAll('.mobile-dot'); for (var i=0;i<d.length;i++) d[i].classList.toggle('mobile-dot--active', i===idx); };

  // ---------- patch + lifecycle ----------
  P.patchCarousel = function(){
    var self=this; this._origScrollTo = this.carousel.scrollToElement;
    this.carousel.scrollToElement = function(el){ var i=self.reals().indexOf(el); if (i>=0) self.animateToIndex(i); };
  };
  P.bindLifecycle = function(){
    var self=this;
    this._onResize = function(){
      if (!window.matchMedia(MOBILE).matches){ self.teardown(); return; }
      var w=Math.round(self.slider.getBoundingClientRect().width);
      if (w && w!==self.W){ self.W=w; self.pos=self.target=self.offsetFor(self.index); self.apply(); }
    };
    window.addEventListener('on:debounced-resize', this._onResize);
    this._mo = new MutationObserver(function(){ if (self.reals().length !== self.n) self.rebuild(); });
    this._mo.observe(this.grid, { childList:true, attributes:true, attributeFilter:['hidden'] });
  };
  P.rebuild = function(){ if (this.lead&&this.lead.parentNode) this.lead.remove(); if (this.trail&&this.trail.parentNode) this.trail.remove(); this.lastEmitIdx=-1; this.build(); this.buildDots(); this.emitFull(); };
  P.teardown = function(){ try{ if (this.lead&&this.lead.parentNode) this.lead.remove(); if (this.trail&&this.trail.parentNode) this.trail.remove(); this.grid.style.transition=''; this.grid.style.transform=''; this.carousel.classList.remove('momentum-active'); if (this._origScrollTo) this.carousel.scrollToElement=this._origScrollTo; if (this._mo) this._mo.disconnect(); window.removeEventListener('on:debounced-resize', this._onResize); this.carousel.__momentum=null; }catch(e){} };

  // ---------- arranque ----------
  function attach(){
    if (!window.matchMedia(MOBILE).matches) return;
    var list = document.querySelectorAll('carousel-slider[data-momentum="true"]');
    for (var i=0;i<list.length;i++){ var cs=list[i]; if (cs.__momentum) continue; try { new MomentumGallery(cs); } catch(e){} }
  }
  function boot(){ if (window.customElements && customElements.whenDefined){ customElements.whenDefined('carousel-slider').then(function(){ setTimeout(attach,60); }); } else setTimeout(attach,120); }
  ready(boot);

  // Re-enganche persistente: al rotar landscape->portrait teardown() deja __momentum=null y quita su
  // listener de instancia; este listener de MÓDULO (no se borra nunca) vuelve a montar el momentum al
  // re-entrar en rango móvil. attach() es idempotente (salta si ya hay controlador).
  function onViewportChange(){ if (window.matchMedia(MOBILE).matches) attach(); }
  window.addEventListener('on:debounced-resize', onViewportChange);
  window.addEventListener('orientationchange', function(){ setTimeout(onViewportChange, 150); });

  // ---------- EDITOR DEL THEME (Shopify.designMode) ----------
  // Fuera del editor este bloque NO se ejecuta: el comportamiento del storefront queda idéntico.
  // En el editor fallan dos supuestos del módulo: (1) el iframe asienta el layout TARDE y cambia el
  // ancho del slider sin evento resize (y a anchos fraccionales el Math.round de build() deriva
  // ~0.5px/slide), y (2) al tocar un setting el editor re-renderiza la sección (shopify:section:load)
  // sustituyendo el DOM del carrusel. Aquí: W exacto (float) re-medido antes de cada gesto +
  // ResizeObserver, teardown/re-attach en los eventos de sección, y rescate de instancias muertas.
  if (window.Shopify && Shopify.designMode && !window.__pdpMomentumEditor){
    window.__pdpMomentumEditor = true; // el editor re-ejecuta los scripts de sección en cada re-render: no duplicar listeners
    var edSyncW = function(cs){
      var m = cs.__momentum;
      if (!m || !m.ok || !m.slider || m.dragging) return;
      // El editor hace scrollIntoView() del elemento seleccionado y eso SCROLLEA el .slider aunque
      // tenga overflow:hidden (scroll programático) => la galería queda corrida a mitad de foto y el
      // momentum (que posiciona por transform) ni se entera. Resetear siempre.
      if (m.slider.scrollLeft) m.slider.scrollLeft = 0;
      var w = m.slider.getBoundingClientRect().width; // float: sin la deriva de redondeo en anchos fraccionales
      if (!w || Math.abs(w - m.W) < 0.1) return;
      m.W = w;
      m.target = m.offsetFor(m.index);
      m.startTick(); // converge animado al encuadre correcto (sin teleport visible)
    };
    var edSyncAll = function(){
      var list = document.querySelectorAll('carousel-slider[data-momentum="true"]');
      for (var i = 0; i < list.length; i++){
        var m = list[i].__momentum;
        if (m && !m.ok) list[i].__momentum = null; // instancia muerta (W=0 en build): dejar que attach() la recree
        if (list[i].__momentum) edSyncW(list[i]);
      }
      attach(); // idempotente: solo monta donde falte controlador
    };
    // W exacto justo ANTES de que onDown fije dragBase (capture => corre primero)
    document.addEventListener('pointerdown', function(e){
      var cs = e.target && e.target.closest && e.target.closest('carousel-slider[data-momentum="true"]');
      if (cs) edSyncW(cs);
    }, true);
    document.addEventListener('shopify:section:unload', function(e){
      var list = e.target ? e.target.querySelectorAll('carousel-slider[data-momentum="true"]') : [];
      for (var i = 0; i < list.length; i++){ var m = list[i].__momentum; if (m && m.teardown) m.teardown(); }
    });
    document.addEventListener('shopify:section:load', function(){ setTimeout(edSyncAll, 120); });
    document.addEventListener('shopify:section:select', function(){ setTimeout(edSyncAll, 120); });
    document.addEventListener('shopify:block:select', function(){ setTimeout(edSyncAll, 120); });
    // matar en el acto cualquier scroll horizontal programático del editor sobre el .slider
    document.addEventListener('scroll', function(e){
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('slider')) return;
      var cs = t.closest && t.closest('carousel-slider[data-momentum="true"]');
      if (cs && cs.__momentum && cs.__momentum.ok && t.scrollLeft) t.scrollLeft = 0;
    }, true);
    // carga inicial del editor: el layout del iframe puede asentar después del boot()
    var lateSyncs = [300, 900, 2000];
    for (var s = 0; s < lateSyncs.length; s++) setTimeout(edSyncAll, lateSyncs[s]);
    if (window.ResizeObserver){
      var edRO = new ResizeObserver(function(entries){
        for (var j = 0; j < entries.length; j++){
          var cs = entries[j].target.closest('carousel-slider[data-momentum="true"]');
          if (cs && cs.__momentum) edSyncW(cs);
        }
      });
      var edWatch = function(){
        var l = document.querySelectorAll('carousel-slider[data-momentum="true"] .slider');
        for (var k = 0; k < l.length; k++) edRO.observe(l[k]); // re-observe del mismo nodo es no-op
      };
      setTimeout(edWatch, 200);
      document.addEventListener('shopify:section:load', function(){ setTimeout(edWatch, 250); });
    }
  }
})();
